import {NgModule} from '@angular/core';
import {DxAutocompleteModule, DxDataGridModule} from 'devextreme-angular';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {PageTopComponent} from './componentes/page-top/page-top.component';
import {MaskDirective} from './diretivas/mask.directive';
import {PopUpTemplateComponent} from './componentes/pop-up/pop-up-template/pop-up-template.component';
import {FocoInicialDirective} from './diretivas/foco-inicial.directive';
import {TabPageTopComponent} from './componentes/tab-page-top/tab-page-top.component';
import { PagamentoFormComponent } from './componentes/pagamento-form/pagamento-form.component';
import { TermosCondicoesPIComponent } from './componentes/termos-condicoes/termos-condicoes-pi/termos-condicoes-pi.component';
import { TermosCondicoesMTComponent } from './componentes/termos-condicoes/termos-condicoes-mt/termos-condicoes-mt.component';

@NgModule({
  declarations: [
    PageTopComponent,
    MaskDirective,
    FocoInicialDirective,
    PopUpTemplateComponent,
    TabPageTopComponent,
    PagamentoFormComponent,
    TermosCondicoesPIComponent,
    TermosCondicoesMTComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    DxDataGridModule,
    DxAutocompleteModule,
    FocoInicialDirective,
    MaskDirective,
    PageTopComponent,
    PopUpTemplateComponent,
    TabPageTopComponent,
    TermosCondicoesPIComponent,
    TermosCondicoesMTComponent,
    PagamentoFormComponent,
  ],
})

export class CompartilhadoModule {
}
